import { Component } from 'react';
import styles from './DocumentTypeAction.module.css';

export class DocumentTypeAction extends Component<{
    onClick: (documentType: string) => void;
    documentType: string;
    label: React.ReactNode;
    icon: React.ReactNode;
}> {
    handleOnClick = () => {
        const { onClick, documentType } = this.props;
        onClick(documentType);
    };

    render() {
        const { label, icon } = this.props;

        return (
            <div
                className={styles.DocumentTypeAction}
                onClick={this.handleOnClick}
            >
                {icon}
                <label>{label}</label>
            </div>
        );
    }
}
